import { createDefaultProposalFilters } from '@/utils/workerCreditContractManagement';

export default {
  SET_PROPOSAL_DATA(state, data) {
    state.proposal = data;
  },
  SET_FILTERS(state, data) {
    state.filters = data;
  },
  UPDATE_FILTERS(state, data) {
    state.filters = { ...state.filters, ...data };
  },
  SET_FILTER_SEARCHED(state, data) {
    state.filterSearched = data;
  },
  RESET_FILTERS(state) {
    state.filters = createDefaultProposalFilters();
  },
};
